import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "opengldeviceinfo"
    }}>{`OpenGLDeviceInfo`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "driverversion"
    }}>{`driverVersion`}</h3>
    <p>{`• `}<strong parentName="p">{`driverVersion`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "gldriver"
    }}>{`glDriver`}</h3>
    <p>{`• `}<strong parentName="p">{`glDriver`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "isintegrated"
    }}>{`isIntegrated`}</h3>
    <p>{`• `}<strong parentName="p">{`isIntegrated`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "memorymb"
    }}>{`memoryMB`}</h3>
    <p>{`• `}<strong parentName="p">{`memoryMB`}</strong>{`: `}<em parentName="p">{`number`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "name"
    }}>{`name`}</h3>
    <p>{`• `}<strong parentName="p">{`name`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "vendor"
    }}>{`vendor`}</h3>
    <p>{`• `}<strong parentName="p">{`vendor`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "version"
    }}>{`version`}</h3>
    <p>{`• `}<strong parentName="p">{`version`}</strong>{`: `}<em parentName="p">{`string`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      